import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom"  
import Loading from "../../components/loading";
import Swal from "sweetalert2";
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import ModalSearchAuthorizations from "./modals/modalSearchAuthorizations";
import ModalAuthorizationsComments from "./modals/modalAuthorizationsComments"; 
import ModalAuthorizationsView from "./modals/modalAuthorizationsView";
import ModalAuthorizationsUpload from "./modals/modalAuthorizationsUpload";
// Services
import OperationFileService from "../../services/operationFileService";
import ListService from "../../services/listService";
import ModalAuthorizationsLog from "./modals/modalAuthorizationsLog";

function Authorizations() {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [sending, setSending] = useState(false);
    const initialized = useRef(false)
    const [modalSearchOpen, setModalSearchOpen] = useState(false);
    const [modalLogOpen, setModalLogOpen] = useState(false);
    const [modalCommentsOpen, setModalCommentsOpen] = useState(false);
    const [modalViewOpen, setModalViewOpen] = useState(false);
    const [modalUploadOpen, setModalUploadOpen] = useState(false);
    const [bonoSelected, setBonoSelected] = useState('');
    const [listOperations, setListOperations] = useState([])
    const [listOperationLinks, setListOperationLinks] = useState([])
    const [listOperationMeta, setListOperationMeta] = useState([])
    const [listStatus, setListStatus] = useState([])
    const [listOficials, setListOficials] = useState([])
    const [listOperationTypes, setListOperationTypes] = useState([])
    const [listOperationReasons, setListOperationReasons] = useState([])
    const userProfile = JSON.parse(sessionStorage.getItem("userProfile"));

    // Search Form
    let defaultDate = new Date().toISOString().slice(0,10);
    const [searchModel, setSearchModel] = useState({
        account: '',
        status: '',
        dateFrom: defaultDate,
        dateTo: defaultDate,
        filename: '',
        oficial: null,
        active: true,
        status: null,
        opetype: null,
        opereason: null,
        orderby: '-fecha_de_concertacion'
    })

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true
            doSearch()
        }
    }, [false]);

    const doSearch = async (event) => {
        try {  
            setLoading(true)
            const response = await OperationFileService.getOperationFileSearch(searchModel)
            setListOperations(response.data)
            setListOperationLinks(response.links)
            setListOperationMeta(response.meta)
            // Status
            const responseStatus = await ListService.getEscoOperationsStatusList()
            setListStatus(responseStatus.data)
            const responseOficials = await ListService.getAccountManagersList()
            setListOficials(responseOficials.data[0])
            const responseOperationTypes = await ListService.getFileOperationTypesList()
            setListOperationTypes(responseOperationTypes.data[0])
            const responseOperationReasons = await ListService.getOperationReasonsList()
            setListOperationReasons(responseOperationReasons.data)
            
        } catch (err) {
            if(err.response.status !== 401){
                Swal.fire({
                    title: 'Ooops?',
                    text: err.response.data.errors[0].detail,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }else{
                sessionStorage.removeItem("userProfile");
                navigate('/')
                window.location.reload();
            }
        } finally{ setLoading(false) }
    }
    
    const doExport = async () => {
        var filters = '';
        if(searchModel.dateFrom !== '' && searchModel.dateFrom !== ""){ filters += '&filter[from]='+searchModel.dateFrom; }
        if(searchModel.dateTo !== '' && searchModel.dateTo !== ""){ filters += '&filter[to]='+searchModel.dateTo; }
        if(searchModel.account !== '' && searchModel.account !== null){ filters += '&filter[comitente]='+searchModel.account; }
        if(searchModel.status !== '' && searchModel.status !== null){ filters += '&filter[status]='+searchModel.status; }
        if(searchModel.oficial !== '' && searchModel.oficial !== null){ filters += '&filter[oficialDeCuenta]='+searchModel.oficial; }
        if(searchModel.opetype !== '' && searchModel.opetype !== null){ filters += '&filter[tipoOperacion]='+searchModel.opetype; }
        if(searchModel.opereason !== '' && searchModel.opereason !== null){ filters += '&filter[escoOperationReasonToSend]='+searchModel.opereason; }
        // console.log(process.env.REACT_APP_API_URL+"esco-operation-details/download/excel?token="+userProfile.token+filters)
        window.open(process.env.REACT_APP_API_URL+"esco-operation-details/download/excel?token="+userProfile.token+filters, '_blank');
    }

    const doView = async (obj, target) => {
        if(obj !== null){
            setBonoSelected(obj)
            if(target === 1){ // VER
                setModalViewOpen(true)
            }else if(target === 2){ // LOGS
                setModalLogOpen(true)
            }else if(target === 3){ // COMENTARIOS
                setModalCommentsOpen(true)
            }
        }
    }
   
    const doOpenModalSearch = async () => { setModalSearchOpen(true) }
   
    const doOpenModalUpload = async () => { setModalUploadOpen(true) }
   
    const doCancelSend = async (id) => {
        Swal.fire({
            title: "Atención!",
            text: "Ud. esta seguro que quiere RECHAZAR el envio realizado ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Rechazar",
            confirmButtonColor: "#83766d"
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    const response = OperationFileService.putOperationAuthStatus(id, {esco_operation_status_id: 4})
                    doSearch() 
                } catch (err) {
                    if(err.response.status !== 401){
                        Swal.fire({
                            title: 'Ooops?',
                            text: err.response.data.errors[0].detail,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#f13939'
                        })
                    }else{
                        sessionStorage.removeItem("userProfile");
                        navigate('/')
                        window.location.reload();
                    }
                }
            }
        });
    }

    const doPagination = async () => {
        try {  
            setLoading(true)
            const response = await OperationFileService.getOperationsFilePagination(listOperationLinks.next)
            response.data.forEach( data => listOperations.push(data) )
            setListOperationLinks(response.links)
            setListOperationMeta(response.meta)
        } catch (err) {
            if(err.response.status !== 401){
                Swal.fire({
                    title: 'Ooops?',
                    text: err.response.data.errors[0].detail,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#f13939'
                })
            }else{
                sessionStorage.removeItem("userProfile");
                navigate('/')
                window.location.reload();
            }
        } finally{ setLoading(false) }
    }

    if(loading){
        return( <Loading></Loading> )
    }

    return (
        <div className="container-fluid flex-grow-1 container-p-y">

            <div className="row">
                <div className="col">
                    <h4 className="fw-bold py-3 mb-2">
                        Reporte Autorizaciones de Operaciones 
                        {listOperationMeta.total > 0 && <span className="fontMedium">({listOperationMeta.total})</span> }
                    </h4>
                </div>
                <div className="col">
                    <div className="btn-group float-end" role="group" aria-label="First group">
                        {listOperations.length > 0 &&
                            <button type="button" className="btn btn-outline-secondary" title="Exportar" onClick={doExport} >
                                <i className="tf-icons bx bx bx-cloud-download" />
                            </button>
                        }
                        { userProfile.roleid === 1 &&
                            <button type="button" className="btn btn-outline-secondary" title="Importar" onClick={doOpenModalUpload}>
                                <i className="tf-icons bx bx bx-cloud-upload" />
                            </button>
                        }
                        <button type="button" className="btn btn-outline-secondary" onClick={doOpenModalSearch} >
                            <i className="tf-icons bx bx-filter" />
                        </button>
                    </div>
                </div>
            </div>

            <div className="row">
                <table className="table table-striped table-hover" >
                    <thead style={{backgroundColor: '#FFFFFF'}}>
                        <tr className="text-nowrap">
                            <th>Comitente</th>
                            <th>Moneda</th>
                            <th>Tipo de Operación</th>
                            <th>Abreviatura</th>
                            <th>Concertación</th>
                            <th className="text-end">Cantidad</th>
                            <th className="text-end">Precio</th>
                            <th className="text-end">Bruto</th>
                            <th>Oficial</th>
                            <th>Estado</th>
                            <th>Enviado</th>
                            <th>Firmado</th>
                            <th>Razon</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody className="table-border-bottom-0">
                        { listOperations.map((operation, index) => (
                            <tr key={operation.id} className="small">
                                <td>
                                    <div className="d-flex justify-content-start align-items-center user-name">
                                        <div className="d-flex flex-column">
                                            <a className="text-body text-truncate">
                                                <span className="fw-medium">
                                                    {operation.comitente_descripcion.length > 30 ?
                                                        `${operation.comitente_descripcion.substring(0, 30)}...` : operation.comitente_descripcion
                                                    }
                                                </span>
                                            </a>
                                            <small className="text-muted"><span className="badge bg-label-dark">{operation.comitente_numero}</span></small>
                                        </div>
                                    </div>
                                </td>
                                <td><span className="badge bg-label-info me-1">{operation.moneda_descripcion}</span></td>
                                <td>{operation.tipo_de_operacion_descripcion}</td>
                                <td>{operation.instrumento_abreviatura}</td>
                                <td>
                                    <div className="d-flex justify-content-start align-items-center user-name">
                                        <div className="d-flex flex-column">
                                            <a className="text-body text-truncate ">
                                                <span className="fw-medium">
                                                    {moment(operation.fecha_de_concertacion).format('DD/MM/YYYY')}
                                                </span>
                                            </a>
                                        </div>
                                    </div>
                                </td>
                                <td className="text-end">
                                    <NumericFormat 
                                        displayType="text" 
                                        value={operation.cantidad} 
                                        decimalScale={0} 
                                        allowLeadingZeros thousandSeparator="." 
                                        decimalSeparator="," 
                                    /> 
                                </td>
                                <td className="text-end">
                                    <NumericFormat 
                                        displayType="text" 
                                        value={operation.precio} 
                                        decimalScale={2} 
                                        allowLeadingZeros thousandSeparator="." 
                                        decimalSeparator="," 
                                        prefix={'$'}  
                                    /> 
                                </td>
                                <td className="text-end">
                                    <NumericFormat 
                                        displayType="text" 
                                        value={operation.bruto} 
                                        decimalScale={2} 
                                        allowLeadingZeros thousandSeparator="." 
                                        decimalSeparator="," 
                                        prefix={'$'}  
                                    /> 
                                </td>
                                <td className="small">{operation.oficial_de_cuenta_descripcion}</td>
                                <td>
                                    {operation.esco_operation_status_id === 1 && <span className="badge bg-label-warning me-1">{operation.esco_operation_status.display_name}</span>}
                                    {operation.esco_operation_status_id === 2 && <span className="badge bg-label-info me-1">{operation.esco_operation_status.display_name}</span>}
                                    {operation.esco_operation_status_id === 3 && <span className="badge bg-label-success me-1">{operation.esco_operation_status.display_name}</span>}
                                    {operation.esco_operation_status_id === 4 && <span className="badge bg-label-danger me-1">{operation.esco_operation_status.display_name}</span>}
                                </td>
                                <td className="small">
                                    {operation.sent_at !== null && 
                                        <div className="d-flex justify-content-start align-items-center user-name"  onClick={() => {  doView(operation, 2) } }>
                                            <div className="d-flex flex-column">
                                                <a className="text-body text-truncate ">
                                                    <span className="fw-medium">
                                                        {moment(operation.sent_at).format('DD/MM/YYYY')}
                                                    </span>
                                                </a>
                                                <small className="text-muted">{moment(operation.sent_at).format('HH:mm')}</small>
                                                {/* <small className="text-muted">{operation.sent_at}</small> */}
                                            </div>
                                        </div>
                                    }
                                </td>
                                <td className="small">
                                    {operation.signed_at !== null && 
                                        <div className="d-flex justify-content-start align-items-center user-name">
                                            <div className="d-flex flex-column">
                                                <a className="text-body text-truncate ">
                                                    <span className="fw-medium">
                                                        {moment(operation.signed_at).format('DD/MM/YYYY')}
                                                    </span>
                                                </a>
                                                <small className="text-muted">{moment(operation.signed_at).format('HH:MM')}</small>
                                            </div>
                                        </div>
                                    }
                                    
                                </td>
                                <td className="small">{operation.esco_operation_reason_to_send_id !== null && operation.esco_operation_reason_to_send.display_name}</td>
                                <td className="text-end">
                                    <div className="dropdown">
                                        <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                            <i className="bx bx-dots-vertical-rounded" />
                                        </button>
                                        <div className="dropdown-menu">
                                            <a className="dropdown-item" href="#"  onClick={() => {  doView(operation, 1) } }>Ver</a>
                                            {/* <a className="dropdown-item" href="#"  onClick={() => {  doView(operation, 3) } }>Comentarios</a> */}
                                            {(operation.esco_operation_status_id === 2 && userProfile.role === 'super-admin') && <a className="dropdown-item" href="#" onClick={() => {  doCancelSend(operation.id) } }>Rechazar Envio</a>}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                { listOperationLinks.next !== null ?
                    <div className="row mt-4">
                        <div className="col d-grid gap-2 d-md-flex justify-content-md-center">
                        { sending ? 
                            <div className="d-flex justify-content-center">
                                <div className="spinner-border text-info" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        : 
                            <button type="button" className="btn btn-outline-info" onClick={doPagination}>Mas Información</button>
                        }
                        </div>
                    </div>
                :
                    null
                }
            </div>

             {/* SEARCH */}
             <ModalSearchAuthorizations
                handleOpen={setModalSearchOpen} 
                isOpen={modalSearchOpen} 
                setSearch={setSearchModel}
                search={searchModel}
                doSearch={doSearch}
                listStatus={listStatus}
                listOficials={listOficials}
                listOperationTypes={listOperationTypes}
                listOperationReasons={listOperationReasons}
            />

            { bonoSelected !== '' &&
            <>
                <ModalAuthorizationsLog 
                    handleOpen={setModalLogOpen} 
                    isOpen={modalLogOpen} 
                    log={bonoSelected.esco_operation_mail_logs}
                />
                
                <ModalAuthorizationsComments 
                    handleOpen={setModalCommentsOpen} 
                    isOpen={modalCommentsOpen} 
                    title={bonoSelected.comitente_numero + " - " + bonoSelected.comitente_descripcion}
                />
                
                <ModalAuthorizationsView 
                    handleOpen={setModalViewOpen} 
                    isOpen={modalViewOpen} 
                    selected={bonoSelected}
                />
            </>
                
            }

            {/* UPLOAD */}
            { userProfile.roleid === 1 &&
                <ModalAuthorizationsUpload
                    handleOpen={setModalUploadOpen} 
                    isOpen={modalUploadOpen} 
                />
            }
        </div>   
    );

}

export default Authorizations;